import { createRouter, createWebHistory } from 'vue-router';
import Login from './components/Login.vue';
import TimeTracking from './components/TimeTracking.vue';
import Profile from './components/Profile.vue';


const routes = [
  { path: '/login', name:'login', component: Login },
  { path: '/timetracking', name:'timeTracking', component: TimeTracking },
  { path: '/profile', name:'profile', component: Profile },

  { path: '/:pathMatch(.*)*', redirect: '/login' },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (to.path === '/login' && token) {
    next('/timetracking');
  } else if ((to.path === '/timetracking' || to.path === '/profile') && !token) {
    next('/login');
  } else {
    next();
  }
});

export default router;
